import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Button, FormGroup, Col, Input, Label, Table, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import authorizedFetch, { authorizedPost } from '../api-authorization/AuthorizedFetch';
import WithLoader from '../WithLoader';
import { safeParseResponse } from '../../utils';

export const NewSchoolPanel = ({ isOpen, toggle, onSaved }) => {
  const [schoolName, setSchoolName] = useState('');

  const schoolNameChanged = e => 
    setSchoolName(e.target?.value || '');

  const save = async () => {
    const response = await authorizedPost('api/schools', { name: schoolName });
    const { schoolId } = await safeParseResponse(response) || {};
    toggle();
    onSaved && onSaved(schoolId);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Add School
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup row>
            <Label for="schoolName" sm={2}>Name</Label>
            <Col sm={10}>
              <Input 
                id="schoolName" 
                name="email" 
                placeholder="School Name" 
                onChange={schoolNameChanged} 
                value={schoolName} 
              />
            </Col>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={save}
        >
          Create
        </Button>
        <Button onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

const SchoolList = () => {
  const history = useHistory();

  const [reloadCount, setReloadCount] = useState(0);
  const [schools, setSchools] = useState([]);
  const [newSchoolIsOpen, setNewSchoolIsOpen] = useState(false);

  const fetchSchools = async done => {
    const response = await authorizedFetch('api/schools');
    const schools = await safeParseResponse(response) || [];
    setSchools(schools);
    done();
  };

  const goToSchool = e => {
    const schoolId = e.currentTarget?.dataset?.schoolId;
    history.push(`/admin/schools/${schoolId}`);
  };

  const onNewSchoolSaved = () => setReloadCount(reloadCount + 1);

  const toggleNewSchool = () => setNewSchoolIsOpen(!newSchoolIsOpen);

  return (
    <WithLoader key={reloadCount} action={fetchSchools}>
      <Table hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th><Button color='primary' onClick={toggleNewSchool}>New School</Button></th>
          </tr>
        </thead>
        <tbody>
          {
            schools.map(({ name, schoolId }) => {
              return (
                <tr 
                  key={schoolId} 
                  data-school-id={schoolId} 
                  onClick={goToSchool}
                >
                  <td>{name}</td>
                  {/* todo - Do we need this empty cell? */}
                  <td></td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
      <NewSchoolPanel isOpen={newSchoolIsOpen} toggle={toggleNewSchool} onSaved={onNewSchoolSaved} />
    </WithLoader>
  );
}

export default SchoolList;